import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import rest from '../axios'; // Usando o 'rest' já configurado no seu arquivo 'api.js'
import './css/CondominiumComponent.css';

const CategoriesComponent = () => {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [newCategory, setNewCategory] = useState({ name: '' });
  const [editCategory, setEditCategory] = useState({ id: '', name: '' });
  const [deleteCategoryPassword, setDeleteCategoryPassword] = useState(''); // Senha digitada pelo usuário

  useEffect(() => {
    rest.get('/admin/categories')
      .then((response) => {
        const uniqueCategories = response?.data?.data?.filter((value, index, self) =>
          index === self.findIndex((t) => t.name === value.name)
        );
        setCategories(uniqueCategories);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  const handleAddCategory = () => {
    rest.post('/admin/categories', newCategory)
      .then(() => {
        setShowAddCategoryModal(false);
        setNewCategory({ name: '' });
        rest.get('/admin/categories').then((response) => {
          setCategories(response.data?.data || []);
        });
      })
      .catch((error) => {
        console.error('Error adding category:', error);
      });
  };

  const handleEditCategory = () => {
    rest.put(`/admin/categories/${editCategory.id}`, editCategory)
      .then(() => {
        setShowEditCategoryModal(false);
        rest.get('/admin/categories').then((response) => {
          setCategories(response.data?.data || []);
        });
      })
      .catch((error) => {
        console.error('Error editing category:', error);
      });
  };

  const handleDeleteCategory = () => {
    rest.delete(`/admin/categories/${selectedCategory.id}`, {
      data: { password: deleteCategoryPassword },
    })
      .then(() => {
        setShowDeleteCategoryModal(false);

        // Remove a categoria da lista localmente para evitar duplicatas
        const updatedCategories = categories.filter(
          (category) => category.id !== selectedCategory.id
        );

        setCategories(updatedCategories);  // Atualiza a lista localmente
      })
      .catch((error) => {
        console.error('Error deleting category:', error);
      });
  };


  return (
    <div className="containeri">
      {/* Botão Adicionar Categoria */}
      <div className="mb-3">
        <button className="btn btn-primary" onClick={() => setShowAddCategoryModal(true)}>
          Adicionar Categoria
        </button>
      </div>

      {/* Contêiner da tabela com rolagem */}
      <div className="table-responsive">
        <table className="table mt-4" id="categoryTable">
          <thead>
            <tr>
              <th>Categoria</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category.id}>
                <td>{category.name}</td>
                <td className="d-flex flex-column">
                  <button
                    className="btn btn-warning mb-2"
                    onClick={() => {
                      setSelectedCategory(category);
                      setEditCategory({ id: category.id, name: category.name });
                      setShowEditCategoryModal(true);
                    }}
                  >
                    Editar Categoria
                  </button>
                  <button
                    className="btn btn-danger mb-2"
                    onClick={() => {
                      setSelectedCategory(category);
                      setShowDeleteCategoryModal(true);
                    }}
                  >
                    Excluir Categoria
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Adicionar Categoria */}
      <Modal show={showAddCategoryModal} onHide={() => setShowAddCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Nome da Categoria</Form.Label>
              <Form.Control
                type="text"
                value={newCategory.name}
                onChange={(e) => setNewCategory({ name: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddCategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAddCategory}>
            Adicionar Categoria
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Categoria */}
      <Modal show={showEditCategoryModal} onHide={() => setShowEditCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Nome da Categoria</Form.Label>
              <Form.Control
                type="text"
                value={editCategory.name}
                onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditCategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleEditCategory}>
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Excluir Categoria */}
      <Modal show={showDeleteCategoryModal} onHide={() => setShowDeleteCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Digite sua senha para confirmar:</Form.Label>
              <Form.Control
                type="password"
                value={deleteCategoryPassword}
                onChange={(e) => setDeleteCategoryPassword(e.target.value)}
              />
            </Form.Group>
            <p>
              Tem certeza de que deseja excluir a categoria <strong>{selectedCategory?.name}</strong>?
            </p>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteCategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteCategory}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CategoriesComponent;
